import { Injectable } from '@angular/core';
import { MessageService, MessageIndexedDBInitiated } from './message.service';
import { SharedUtilService } from './shared-util.service';

export const LASTREADTABLE = 'LASTREADTABLE';
@Injectable({
  providedIn: 'root'
})
export class IndexedDBService {
  db;
  initialSuccess = false;
  constructor(private messageService: MessageService) {
    this.openDB('personalweb', 1);
  }

  private indexedDBOk() {
    return 'indexedDB' in window;
  }

  private notSupportIDB() {
    if (typeof(this.db) == 'undefined' || !SharedUtilService.isPC()) {
      return true;
    } else {
      return false;
    }
  }

  private openDB (name, ver) {
    if (!this.indexedDBOk()) {
      return;
    }
    const version = ver || 1;
    const request = window.indexedDB.open(name, version);
    request.onerror = (e: any) => {
      // let target:IDBOpenDBRequest = e.currentTarget
      this.initialSuccess = true;
      console.log(e.currentTarget.error.message);
    };
    request.onsuccess = (e: any) => {
      this.db = e.target.result;
      this.initialSuccess = true;
      console.log('openDB: onsuccess' + e.target.result);
      this.messageService.sendMessage({name: MessageIndexedDBInitiated});
    };
    request.onupgradeneeded = (e: any) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(LASTREADTABLE)) {
        db.createObjectStore(LASTREADTABLE, {keyPath: 'fileurl'});
      }
      console.log('DB version changed to ' + version);
    };
  }

  // NOTE not used
  // private closeDB() {
  //   if (this.notSupportIDB()) {
  //     return;
  //   }
  //   this.db.close();
  // }

  addData(storeName, data) {
    console.log('idb addData: ' + typeof(this.db));
    if (this.notSupportIDB()) {
      return;
    }
    const transaction = this.db.transaction(storeName, 'readwrite');
    const store = transaction.objectStore(storeName);
    store.add(data);
    console.log('idb addData - store finished ');
  }

  getDataByKey(storeName, key, callback) {
    console.log('idb getDataByKey: ' + typeof(this.db));
    if (this.notSupportIDB()) {
      callback(null);
      return;
    }
    const transaction = this.db.transaction(storeName, 'readwrite');
    const store = transaction.objectStore(storeName);
    const request = store.get(key);
    request.onsuccess = (e) => {
      console.log('idb getDataByKey - request.onsuccess ');
      const data = e.target.result;
      callback(data);
    };
    request.onerror = () => {
      console.log('idb getDataByKey - request.onerror ');
      callback(null);
    }
  }

  updateDataByKey(storeName, key, callback) {
    console.log('idb updateDataByKey: ' + typeof(this.db));
    if (this.notSupportIDB()) {
      return;
    }
    const transaction = this.db.transaction(storeName, 'readwrite');
    const store = transaction.objectStore(storeName);
    const request = store.get(key);
    request.onsuccess = (e) => {
      console.log('idb updateDataByKey - request.onsuccess ');
      const data = e.target.result;
      callback(data);
      if(data != null) {
        store.put(data);
      }
    };
  }

  deleteDataByKey(storeName, key) {
    if (this.notSupportIDB()) {
      return;
    }
    const transaction = this.db.transaction(storeName, 'readwrite');
    const store = transaction.objectStore(storeName);
    store.delete(key);
  }

  clearObjectStore(storeName, callback) {
    console.log('idb clearObjectStore: ' + typeof(this.db));
    if (this.notSupportIDB()) {
      return;
    }
    const transaction = this.db.transaction(storeName, 'readwrite');

    transaction.oncomplete = function(event) {
      console.log('idb transaction complete');
    };
  
    transaction.onerror = function(event) {
      console.log('idb transaction error');
    };
    console.log('idb clearObjectStore transaction: ', transaction);
    const store = transaction.objectStore(storeName);
    store.clear().onsuccess = (e) => {
      console.log('idb clearObjectStore success', e);
      callback();
    };
  }

  getAllDatas(storeName, callback) {
    if (this.notSupportIDB()) {
      return;
    }
    const transaction = this.db.transaction(storeName, 'readwrite');
    const store = transaction.objectStore(storeName);
    let list = [];
    store.openCursor().onsuccess = (e) => {
      const cursor = e.target.result;
      if(cursor) {
        list.push(cursor.value);
        cursor.continue();
      }else {
        callback(list);
      }
    }
  }

  //TODO 
  public getFirstItem(storeName, callback) {
    this.getAllDatas(storeName, (list) => {
      if(list.length !=0) {
        callback(list[0]);
      }else {
        callback(null);
      }
    });
  }

  public clear(){
    window.indexedDB.deleteDatabase('personalweb');
  }
}
